import React, { useState } from 'react';
import moment from 'moment';
import { highlightUtilitiesTagHtml } from '../../../../helpers/utilitiesNoteTag';
import { toDisplayableRichTextHtml } from '../../../../helpers/safeHtml';
import { SquareArrowOutUpRight } from 'lucide-react';
import { IoMdArrowDropdown, IoMdArrowDropup } from 'react-icons/io';

const formatNoteTimestamp = note => {
  const when = note?.timestamp ? moment(note.timestamp).format('MMM D, YYYY · h:mm A') : '';
  const wasEdited = note?.editHistory?.length > 0;
  if (!when) return wasEdited ? 'Edited' : '';
  return wasEdited ? `Edited · ${when}` : when;
};

const UtilitiesProcessorNotes = ({ notes = [], serviceId, reserveWorkflowToggle = false }) => {
  const [collapsed, setCollapsed] = useState(false);

  if (!notes.length) return null;

  return (
    <div
      className="mb-3"
      style={{
        marginLeft: -15,
        marginRight: reserveWorkflowToggle ? 68 : -15,
        border: '1px solid #bcd3ee',
        borderLeft: '4px solid #2e75b6',
        background: '#F5F9FE',
        borderRadius: '8px',
        padding: '12px 14px'
      }}
    >
      <button
        type="button"
        className="d-flex flex-wrap justify-content-between align-items-start w-100 border-0 bg-transparent p-0 text-left cursor-pointer"
        onClick={() => setCollapsed(open => !open)}
      >
        <span className="mr-2">
          <b>
            Processor notes tagged <span className="utilities-note-tag">#utilities</span> ({notes.length})
          </b>
        </span>
        <span className="text-muted small font-italic text-nowrap">
          {collapsed ? (
            <>
              Show <IoMdArrowDropdown size={16} />
            </>
          ) : (
            <>
              Hide <IoMdArrowDropup size={16} />
            </>
          )}
        </span>
      </button>

      {!collapsed &&
        notes.map((note, index) => {
          const body = highlightUtilitiesTagHtml(toDisplayableRichTextHtml(note.text));
          return (
            <div className="bg-white border rounded-lg px-3 py-2 mt-2" key={note._id || `${note.timestamp}-${index}`}>
              <div className="d-flex justify-content-between align-items-baseline">
                <b className="midFont mb-0">{note.userName || 'Unknown'}</b>
                <i className="text-muted tinyFont mb-0">{formatNoteTimestamp(note)}</i>
              </div>
              {body ? (
                <div className="mt-1 midFont instruction-content" dangerouslySetInnerHTML={{ __html: body }} />
              ) : null}
              {serviceId && (
                <a
                  className="btn btn-outline-light mt-2 border shadow-none text-dark hover-light d-inline-flex align-items-center"
                  href={`/services/pipeline?${new URLSearchParams({
                    serviceId,
                    orderType: 'Lien Search',
                    ...(note._id ? { noteId: String(note._id) } : {})
                  }).toString()}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <span className="mr-1 d-inline-flex align-items-center flex-shrink-0">
                    <SquareArrowOutUpRight size={14} color="black" />
                  </span>
                  <span className="xsmallFont">View in Service Details</span>
                </a>
              )}
            </div>
          );
        })}
    </div>
  );
};

export default UtilitiesProcessorNotes;
